import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const MonitorAvailabilityDashboard = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      This page breaks down the test cases in your selected monitor configuration, showing the run time data of it's test case runs over a specified period.
    </Color>
  </Paragraph>

export default MonitorAvailabilityDashboard
